import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { onActivated, reactive, toRefs } from "vue";
import { Button, CellGroup, Form, Image as VanImage, Radio, RadioGroup, Toast } from 'vant';
import AppHeader from '@/components-H5/AppHeader.vue';
import apis from "@/api";
import store from '@/store';
import 'vant/es/field/style';
import 'vant/es/button/style';
import 'vant/es/form/style';
import 'vant/es/cell-group/style';
import 'vant/es/radio-group/style';
import 'vant/es/radio/style';
import 'vant/es/toast/style';
export default {
  components: {
    AppHeader,
    VanImage,
    Form,
    CellGroup,
    Button,
    RadioGroup,
    Radio
  },
  setup() {
    let data = reactive({
      posBizList: null,
      formData: {
        posBizs: {},
        qualified: 1,
        remark: ""
      }
    });
    onActivated(() => {
      cleanField();
      data.formData = Object.assign({}, data.formData, store.state.cruiseShop);
      queryPosBiz();
    });
    const queryPosBiz = () => {
      data.formData.posBizs = [];
      apis.getPositionBiz({
        shopId: data.formData.shopId,
        posId: data.formData.posId
      }).then(res => {
        if (res.success) {
          data.posBizList = res.data;
          if (data.posBizList && data.posBizList.length > 0) {
            data.posBizList.forEach(val => {
              data.formData.posBizs.push({
                posBizId: val.id,
                mustPut: val.mustPut
              });
            });
          }
        }
      });
    };
    let sub = 0;
    const onSubmit = () => {
      if (sub != 0) {
        Toast.fail("请勿允许重复提交");
        return;
      }
      sub = 1;
      console.log(data.formData, "values");
      data.formData.posBizs = JSON.stringify(data.formData.posBizs);
      apis.submitCruiseResult(data.formData).then(res => {
        if (res.success) {
          Toast.success("提交成功");
        } else {
          Toast.fail(res.msg);
        }
      });
    };
    const cleanField = () => {
      data.formData.shopName = "";
      data.formData.posName = "";
      data.formData.shopId = "";
      data.formData.posId = "";
      data.formData.remark = "";
      data.formData.posBizs = [];
    };
    return {
      ...toRefs(data),
      queryPosBiz,
      onSubmit,
      cleanField
    };
  }
};